let activeElement,
    navigation = {
        name: 'navigation',
        trigger: $('.js-trigger-navigation'),
        elem: $('.js-target-navigation'),
        active: false,
        overlay: true,
        disabled: false,
        callback: {
            show: function() {
                bLazy.revalidate();

                freezeScroll();
                $('.js-target-navigation').css('max-height', $(window).height() - $('.js-header-navbar').height());
                $('.l-header').addClass('is-open');
            },
            hide: function() {
                unfreezeScroll();
                $('.l-header').removeClass('is-open');
            }
        }
    };

function toggleElem(object) {
    if (object.active) {
        hideElem(object);
    } else {
        showElem(object);
    }
}

function showElem(object) {
    if (activeElement && activeElement.active) {
        hideElem(activeElement);
    }

    object.trigger.addClass('is-active');
    object.elem.addClass('is-active');

    if (object.overlay) {
        showOverlay(250, object.allowScroll);
    }

    if (object.callback && object.callback.show) {
        object.callback.show();
    }

    object.active = true;

    activeElement = object;
}

function hideElem(object) {
    object.trigger.removeClass('is-active');
    object.elem.removeClass('is-active');

    if (object.overlay) {
        hideOverlay();
    }

    if (object.callback && object.callback.hide) {
        object.callback.hide();
    }

    object.active = false;
}

var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('.l-header').outerHeight();

$(window).scroll(function (event) {
    didScroll = true;
});

setInterval(function () {
    if (didScroll) {
        hasScrolled();
        didScroll = false;
    }
}, 250);

function hasScrolled() {
    var st = $(window).scrollTop();

    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta)
        return;

    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight) {
        // Scroll Down
        $('.l-base')
            .removeClass('nav-show')
            .addClass('has-floating-nav nav-hide');
    } else {
        // Scroll Up
        if (st + $(window).height() < $(document).height() && st > navbarHeight) {
            $('.l-base')
                .removeClass('nav-hide')
                .addClass('has-floating-nav nav-show');
        }
        else {
            $('.l-base')
                .removeClass('has-floating-nav nav-hide nav-show');
        }
    }

    lastScrollTop = st;
}

$(function() {
    $(window).on('resize load', function () {
        hasScrolled();

        if ($('.js-target-navigation').is(':visible')) {
            $('.js-target-navigation').css('max-height', $(window).height() - $('.js-header-navbar').height());
        }
    });

    for (const object of [navigation]) {
        object.trigger.on('click', function(event) {
            if (!object.disabled || (object.disabled && !checkResolution(object.disabled))) {
                event.preventDefault();

                toggleElem(object);
            }
            else {
                hideElem(object);
            }
        });
    }

    $('body').on('click', function (event) {
        if (activeElement && activeElement.active) {
            if (!$(event.target).closest(activeElement.elem).length && !$(event.target).closest(activeElement.trigger).length) {
                hideElem(activeElement);
            }
        }
    });
})
